<script lang="ts">
import { defineComponent } from 'vue'
export default defineComponent({
  name: 'StepLaunch',
})
</script>
<template>
  <TlDetailItem :title="title" color="blue">
    <TlDetailField label="发起人">{{ record?.createAdminUserObj?.loginName }}</TlDetailField>
    <TlDetailField label="发起时间">{{ record?.createdAt }}</TlDetailField>
    <TlDetailField label="监审内容名称">{{ record?.name }}</TlDetailField>
    <!-- <TlDetailField label="监审类型"><DictDisplay :value="record?.placeExamineType" /></TlDetailField> -->
    <TlDetailField label="监审金额">{{ record?.placeExaminePrice ?? 0 }} 元</TlDetailField>
    <TlDetailField label="安置监审函">
      <FileDisplayNormals :files="record?.placeExamineReportFiles ?? []" :colAttrs="{ span: 12 }" />
    </TlDetailField>
    <TlDetailField label="安置人员花名册（盖章确认）">
      <FileDisplayNormals :files="record?.placeExamineReportFiles ?? []" :colAttrs="{ span: 12 }" />
    </TlDetailField>
    <TlDetailField label="整改函" v-if="isRenew">
      <FileDisplayNormals :files="record?.placeExamineUpdateFiles ?? []" :colAttrs="{ span: 12 }" />
    </TlDetailField>
  </TlDetailItem>
</template>

<script lang="ts" setup name="StepLaunch">
import { FileDisplayNormals } from '-/Common/FileDisplay'
import TlDetailField from '../common/TlDetailField.vue'
import TlDetailItem from '../common/TlDetailItem.vue'
// import DictDisplay from '../../DictDisplay.vue'
import { computed } from 'vue'
const props = defineProps<{
  record?: any
  isRenew?: boolean
}>()
const title = computed(() => (props.isRenew ? '重新发起' : '发起'))
</script>
